import { FeatureFlag } from '@ps/web-core-enums';
import { LoginSource } from '@ps/web-core-store';

import type { RequestError } from '@swf/core/errors/RequestError';
import idpLogin from '@swf/core/models/auth/idpLogin';
import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { BoundRequestOptions } from '@swf/core/types/Request';

import type { AuthError } from '.';
import { loginError, loginSuccess, sessionTransfer } from './utils';

export interface LoginPayload {
  userId: string;
  password: string;
  rsa?: string;
  pin?: string;
  nemIdLoggedIn?: boolean;
  sessionTransfer?: boolean;
}

const login = async (payload: LoginPayload, { dispatch, request, rootState }: EffectParams) => {
  const { installId } = select.session.get(rootState);
  const isIdpSecondaryLoginEnabled = select.feature.check(
    rootState,
    FeatureFlag.IdpSecondaryLoginEnabled
  );
  const { password } = payload;
  const temporaryPassword = password.startsWith('tmp') ? password : '';
  const options: BoundRequestOptions = {
    service: '/api/v1-preview/auth/session',
    http: true,
    method: 'POST',
    body: { installId, ...payload }
  };

  try {
    const { body } = await (payload.sessionTransfer
      ? sessionTransfer(options, { request })
      : request(options));

    if (isIdpSecondaryLoginEnabled) {
      await idpLogin(payload, { dispatch, rootState });
    }

    await loginSuccess(
      { ...body, loginSource: LoginSource.Login },
      { dispatch },
      temporaryPassword
    );
  } catch (err) {
    return loginError(payload, err as RequestError<AuthError>, dispatch);
  }
};

export default login;
